import { RequestParams, restRepository } from "@onair/repositories";
import {
	checkUserPaymentMethodInUse,
	getFollowings,
	IGetFollowings,
} from "@onair/services/user";
import { useQuery } from "@tanstack/react-query";
import {
	CHECK_USER_PAYMENT_METHOD_IN_USE,
	COUNT_USER_BY_ROLE,
	GET_FOLLOWINGS,
	GET_HOSTS,
	GET_USERS,
} from "../../keys";

export const useGetFollowings = (
	params: IGetFollowings,
	options = { enabled: true },
) => {
	return useQuery({
		queryKey: [GET_FOLLOWINGS, params],
		queryFn: () => getFollowings(params),
		...options,
	});
};

export const useCountUserByRole = () => {
	return useQuery({
		queryKey: [COUNT_USER_BY_ROLE],
		queryFn: async () => {
			const { data } = await restRepository.api.adminCountUserByRole();
			return data;
		},
		enabled: true,
	});
};

export const useGetUsersV2 = (
	searchParams: any,
	options = { enabled: true },
) => {
	return useQuery({
		queryKey: [GET_USERS, searchParams],
		queryFn: async () => {
			const { data } = await restRepository.api.userV2GetAll(searchParams);
			return data;
		},
		...options,
	});
};

export const useCheckPaymentMethodInUse = (bankAccountId: string) => {
	return useQuery({
		queryKey: [CHECK_USER_PAYMENT_METHOD_IN_USE, bankAccountId],
		queryFn: async () => {
			return checkUserPaymentMethodInUse(bankAccountId);
		},
		enabled: !!bankAccountId,
	});
};

interface HostQueryFilter {
	query: { limit: number };
	queryparams?: RequestParams;
}
export const useGetTopHostsQuery = (
	queryFilter: HostQueryFilter,
	options?: { enabled: boolean },
) => {
	const { query, queryparams } = queryFilter;
	const { enabled = true } = options || {};

	return useQuery({
		queryKey: [GET_HOSTS, query],
		queryFn: async () => {
			const { data } = await restRepository.api.userGetTopHosts(
				query,
				queryparams,
			);
			return data;
		},
		enabled: enabled,
	});
};
